<template>
  <div>
    <el-table
      :data="dataList"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="学号" prop="loginName"></el-table-column>
      <el-table-column align="center" label="姓名" prop="userName"></el-table-column>
      <el-table-column align="center" label="性别" prop="sex"></el-table-column>
      <el-table-column align="center" label="入班日期">
        <template slot-scope="scope">
          <span>{{scope.row.createTime | dateFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="350">
        <template slot-scope="scope">
          <el-button @click="changePassword(scope.row)" plain size="small" type="primary" :disabled="Boolean(classInfo.finished_date) && (classInfo.finished_date !== '0001-01-01') && (classInfo.finished_date !== '1900-01-01')">修改密码</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 修改密码dialog -->
    <change-password :resetUse="resetUse" :show="dialogPassword" @close="dialogPassword=false"></change-password>

  </div>
</template>

<script>
import { getClassStudentInfoById} from '@/apiteacher/teacher'
import changePassword from './change-password'


export default {
  props: {
    classStudent: {
      default: () => {
        return []
      },
      type: Array
    },
    classInfo: {
      default: () => {
        return {}
      },
      type: Object
    },pageFrom:{
      default: '',
      type: String
    },
  },
  data () {
    return {
      dataList: [],
      seleStuData: [],
      dialogPassword: false,
      resetUse: {},
      studentCourseObj: null,
      dialogStuCourse: false,
      class_id: '',
      course_id: '',
      user_id: '',
      divideDialog: false,
      adjustDialog:false
    }
  },
  components: { changePassword },
  created () {
    if (!this.classStudent.length) {
      this.getClassStudentInfoById()
    } else {
      this.dataList = this.classStudent
    }
    this.class_id = this.$route.query.classID
    this.course_id = this.$route.query.courseId
  },
  methods: {
    async getClassStudentInfoById () {
      const res = await getClassStudentInfoById({
        class_id: this.$route.query.classID
      })
      this.dataList = res.body
    },

    // 修改密码
    changePassword (row) {
      this.resetUse = row
      this.dialogPassword = true
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
